import React from 'react';
import classNames from 'classnames';
import AnimatedCircle from 'components/Icon/icons/animatedCircle.svg?react';
import Back from 'components/Icon/icons/back.svg?react';
import Bin from 'components/Icon/icons/bin.svg?react';
import Cancel from 'components/Icon/icons/cancel.svg?react';
import Chevron from 'components/Icon/icons/chevron.svg?react';
import ChevronDown from 'components/Icon/icons/chevronDown.svg?react';
import ChevronUp from 'components/Icon/icons/chevronUp.svg?react';
import Confirm from 'components/Icon/icons/confirm.svg?react';
import Copy from 'components/Icon/icons/copy.svg?react';
import Download from 'components/Icon/icons/download.svg?react';
import Edit from 'components/Icon/icons/edit.svg?react';
import Error from 'components/Icon/icons/error.svg?react';
import Info from 'components/Icon/icons/info.svg?react';
import MoveToBottom from 'components/Icon/icons/down.svg?react';
import MoveToTop from 'components/Icon/icons/up.svg?react';
import Plus from 'components/Icon/icons/plus.svg?react';
import Reorder from 'components/Icon/icons/reorder.svg?react';
import Search from 'components/Icon/icons/search.svg?react';
import ThreeDots from 'components/Icon/icons/three-dots.svg?react';
import TickIcon from 'components/Icon/icons/tick.svg?react';
import UpArrow from 'components/Icon/icons/upArrow.svg?react';
import Upload from 'components/Icon/icons/upload.svg?react';
import X from 'components/Icon/icons/x.svg?react';
import classes from './Icon.module.css';

export const iconDetails = {
  animatedCircle: AnimatedCircle,
  back: Back,
  cancel: Cancel,
  chevron: Chevron,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  confirm: Confirm,
  copy: Copy,
  delete: Bin,
  download: Download,
  edit: Edit,
  error: Error,
  info: Info,
  moveToBottom: MoveToBottom,
  moveToTop: MoveToTop,
  plus: Plus,
  reorder: Reorder,
  search: Search,
  tick: TickIcon,
  threeDots: ThreeDots,
  upArrow: UpArrow,
  upload: Upload,
  x: X,
};

interface IconProps {
  iconName: keyof typeof iconDetails;
  className?: string;
}

function Icon({ iconName, className }: IconProps) {
  const IconComponent = iconDetails[iconName];
  const icon = IconComponent ? <IconComponent /> : null;

  if (!IconComponent) {
    console.warn('Incorrect icon name specified');
  }

  return (
    <i aria-hidden className={classNames(classes.iconContainer, className)}>
      {icon}
    </i>
  );
}

export type { IconProps };

export { Icon as default };
